import { connect } from 'react-redux'

import { selectAction, collapseSidebarAction, editModeChangeAction, loadingAction,
deleteFeatureAction, openTourAction, openPanelAction, hidePopupAction, saveFeatureGeomAction, visiblePlacesAction } from './actions'
import FeatureEditorComponent from './FeatureEditorComponent'

const mapStateToProps = state => {
  return {
  	places: state.places,
    selected: state.selected,
    collapsed: state.collapsed,
    editMode: state.editMode,
    loading: state.loading,
    isWaitingForResponse: state.isWaitingForResponse,
    fieldsSchema: state.fieldsSchema,
    isTourOpened: state.isTourOpened,
    isPanelOpened: state.isPanelOpened,
    savePlaceOrCluster: state.savePlaceOrCluster,
    authorizedUser: state.authorizedUser,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSelectClick: selected => dispatch(selectAction(selected)),
    onCollapseSidebar: collapsed => dispatch(collapseSidebarAction(collapsed)),
    onEditModeChange: editMode => dispatch(editModeChangeAction(editMode)),
    onLoading: loading => dispatch(loadingAction(loading)),
    deleteFeature: id => dispatch(deleteFeatureAction(id)),
    openTour: opened => dispatch(openTourAction(opened)),
    openPanel: open => dispatch(openPanelAction(open)),
    doHidePopup: hide => dispatch(hidePopupAction(hide)),
    saveFeatureGeom: (id, placeOrCluster) => dispatch(saveFeatureGeomAction(id, placeOrCluster)),
    onVisiblePlacesChange: (places) => dispatch(visiblePlacesAction(places)),
  }
}

const FeatureEditorContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureEditorComponent)

export default FeatureEditorContainer



// WEBPACK FOOTER //
// ./src/FeatureEditorContainer.js